const scrollBehavior = () => (
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
);

const initializePathRail = (root) => {
  if (root.dataset.homePathReady === 'true') return;
  const rail = root.querySelector('[data-home-path-rail]');
  const cards = [...root.querySelectorAll('[data-home-path-card]')];
  const previous = root.querySelector('[data-home-path-previous]');
  const next = root.querySelector('[data-home-path-next]');
  const progress = root.querySelector('[data-home-path-progress]');
  const selectedName = root.querySelector('[data-home-selected-name]');
  const selectedDescription = root.querySelector('[data-home-selected-description]');
  const continuation = root.querySelector('[data-home-path-continue]');
  const focusIds = ['love', 'career', 'wealth', 'personal-growth', 'spiritual-guidance', 'general-outlook', 'healing'];
  if (!rail || cards.length !== 7 || !previous || !next || !progress || !selectedName || !selectedDescription) return;

  const updateProgress = () => {
    const maximum = rail.scrollWidth - rail.clientWidth;
    const ratio = maximum > 0 ? rail.scrollLeft / maximum : 1;
    progress.style.setProperty('--home-path-progress', `${22 + (ratio * 78)}%`);
  };
  const scrollStep = () => Math.min(390, rail.clientWidth * 0.78);
  previous.addEventListener('click', () => rail.scrollBy({ left: -scrollStep(), behavior: scrollBehavior() }));
  next.addEventListener('click', () => rail.scrollBy({ left: scrollStep(), behavior: scrollBehavior() }));
  rail.addEventListener('scroll', updateProgress, { passive: true });
  cards.forEach((card) => card.addEventListener('click', () => {
    cards.forEach((entry) => {
      const isSelected = entry === card;
      entry.classList.toggle('is-active', isSelected);
      entry.setAttribute('aria-pressed', String(isSelected));
    });
    selectedName.textContent = card.dataset.name;
    selectedDescription.textContent = card.dataset.description;
    if (continuation) {
      const url = new URL(continuation.href, window.location.href);
      url.searchParams.set('focus', focusIds[cards.indexOf(card)]);
      continuation.href = url.href;
    }
    card.scrollIntoView({ behavior: scrollBehavior(), block: 'nearest', inline: 'center' });
  }));
  updateProgress();
  root.dataset.homePathReady = 'true';
};

const initializeProcess = (root) => {
  if (root.dataset.homeProcessReady === 'true') return;
  const detail = root.querySelector('[data-home-process-detail]');
  const steps = [...root.querySelectorAll('[data-home-process-step]')];
  if (!detail || steps.length !== 3) return;
  steps.forEach((step) => step.addEventListener('click', () => {
    steps.forEach((entry) => {
      const isSelected = entry === step;
      entry.classList.toggle('is-active', isSelected);
      entry.setAttribute('aria-pressed', String(isSelected));
    });
    detail.textContent = step.dataset.copy;
  }));
  root.dataset.homeProcessReady = 'true';
};

const initializeWithin = (container) => {
  container.querySelectorAll?.('[data-home-reading-paths]').forEach(initializePathRail);
  container.querySelectorAll?.('[data-home-reading-process]').forEach(initializeProcess);
};

initializeWithin(document);
document.addEventListener('shopify:section:load', (event) => {
  initializeWithin(event.target);
});
